import ApplicationController from './application_controller.js'
import TomSelect from 'tom-select/dist/esm/tom-select.complete'
import { setupI18n } from '../utils/i18n.js'

export default class extends ApplicationController {
  static targets = ['select']
  static values = { locale: String }

  connect() {
    this.i18n = setupI18n(this.localeValue || 'nb')
    const hideSelected = this.element.dataset.hideSelected
    const submitOnChange = this.element.dataset.submitOnChange === 'true'

    if (this.hasSelectTarget) {
      new TomSelect(this.selectTarget, {
        plugins: {
          remove_button: {
            title: this.i18n.t('multiselect.remove')
          },
          clear_button: {
            title: this.i18n.t('multiselect.clear_button'),
            className: 'text-2xl clear-button'
          },
          checkbox_options: {
            className: 'rounded-sm'
          }
        },
        placeholder: this.i18n.t('multiselect.placeholder'),
        onBlur: () => this.submitForm(),
        onClear: () => this.submitForm(),
        onItemRemove: () => this.submitForm(),
        render: {
          item: function (data, escape) {
            // Check if the item is selected and we want to hide selected items
            if (data && hideSelected) {
              return '<div style="display:none;"></div>'
            } else {
              return '<div>' + escape(data['text']) + '</div>'
            }
          }
        }
      })
    }
  }

  submitForm() {
    const submitOnChange = this.element.dataset.submitOnChange === 'true'
    const form = this.selectTarget.closest('form')

    if (submitOnChange) {
      if (form) {
        form.requestSubmit()
      }
    }
  }
}
